module.exports = new __parcel__URL__("avatar-letter-a.c6f06fd3.png").toString();